module.exports = __webpack_public_path__ + "static/media/futwork-logo.d5cabae4.svg";